// extracted by mini-css-extract-plugin
module.exports = {"title":"WrongNetworkModal_title__1cDlb","text":"WrongNetworkModal_text__2ol_I","loading":"WrongNetworkModal_loading__88bYk","rotate":"WrongNetworkModal_rotate__3hFcV"};